import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import Projects from "./pages/Projects/Projects";
import ServicePage from "./pages/Servicepage";
import ServiceDetailsPage from "./pages/ServiceDetailsPage";
import FeaturedNews from "./pages/FeaturedNews/FeaturedNews";
import ContactPage from "./pages/Contact/ContactPage";
import PrincipleDetailsPage from "./pages/PrincipleDetailsPage";
import Careers from "./pages/Careers/Careers";



function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/principles/:slug" element={<PrincipleDetailsPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/services" element={<ServicePage />} />


      <Route path="/services/:slug" element={<ServiceDetailsPage />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/featured-news" element={<FeaturedNews />} />

<Route path="/careers" element={<Careers />} />

        <Route path="/contact" element={<ContactPage />} />
      
    </Routes>
  );
}

export default App;
